import { defineStore } from 'pinia';
import { ref } from 'vue';

// cmer / geek : thèmes du site hôte quand Compet est intégré en iframe (cf. embedHost.ts).
export type Theme = 'calendrier-dark' | 'calendrier-light' | 'cmer' | 'geek';

const DEFAULT_THEME: Theme = 'calendrier-dark';

export const useThemeStore = defineStore('theme', () => {
  const currentTheme = ref<Theme>(DEFAULT_THEME);

  const setTheme = (theme: Theme) => {
    currentTheme.value = theme;
    document.documentElement.setAttribute('data-theme', theme);
  };

  setTheme(DEFAULT_THEME);

  return { currentTheme, setTheme };
});
